import React from "react";

import { PromoCardBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { ButtonPrimary } from "../../Clickables";
import { H } from "../../Headings";
import { getThemeClass } from "../../ThemedModule";
import { VARIANT } from "../index";

import styles from "./SingleCard.module.scss";

interface SingleCardProps {
    card: PromoCardBlock;
}

export const SingleCard = ({ card }: SingleCardProps) => {
    const hasStats = card.stats && card.stats.length > 0;
    const variant = card.variant || VARIANT.IMAGE_FILL;
    const isImageFill = variant === VARIANT.IMAGE_FILL;
    const isImageBlock = variant === VARIANT.IMAGE_BLOCK;

    return (
        <div
            className={concatClassNames([
                styles.singleCard,
                isImageFill ? styles.imageFill : styles.imageBlock,
                isImageBlock ? getThemeClass(card.theme) : "",
            ])}
        >
            {card.image && (
                <div className={styles.imageWrapper}>
                    <ImageChooserBlock value={card.image} attrs={{}} />
                </div>
            )}

            <div className={styles.contentWrapper}>
                <H className={styles.headline}>{card.headline}</H>

                {card.body && <p className={styles.body}>{card.body}</p>}

                {hasStats && (
                    <div className={styles.stats}>
                        {card.stats?.map((stat, index) => (
                            <div key={index} className={styles.statItem}>
                                <div className={styles.statTitle}>
                                    {stat.title}
                                </div>
                                <div className={styles.statBody}>
                                    {stat.body}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {card.link && (
                    <div className={styles.ctaWrapper}>
                        <ButtonPrimary simpleLink={card.link} />
                    </div>
                )}
            </div>
        </div>
    );
};
